(() => {
  function init() {
  const host = document.querySelector('[data-asap-main-mega-menu]');
  if (!host) return;

  const mappedLabels = ['E-Scooter', 'Accessories', 'Support'];
  const panels = new Map(
    [...host.querySelectorAll('[data-asap-main-mega-panel]')].map((panel) => [panel.dataset.asapMainMegaPanel, panel]),
  );
  const navigation = [...document.querySelectorAll('.t4s-navigation')].find((nav) => {
    const labels = [...nav.querySelectorAll(':scope > ul > li > a')].map((link) => link.textContent.trim());
    return mappedLabels.every((label) => labels.includes(label));
  });
  if (!navigation) return;

  const bindings = mappedLabels.map((label) => {
    const trigger = [...navigation.querySelectorAll(':scope > ul > li > a')].find((link) => link.textContent.trim() === label);
    const panel = panels.get(label);
    const item = trigger?.closest('li');
    return trigger && panel && item ? { label, trigger, panel, item } : null;
  }).filter(Boolean);
  if (!bindings.length) return;

  let closeTimer;
  bindings.forEach(({ trigger, panel, item }) => {
    document.body.appendChild(panel);
    trigger.dataset.asapMainMegaTrigger = panel.dataset.asapMainMegaPanel;
    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-controls', panel.id);
    trigger.setAttribute('aria-expanded', 'false');
    item.classList.add('asap-main-mega-menu__item');
  });

  function updateTop() {
    const header = document.querySelector('#shopify-section-header-inline, .t4s-section-header');
    if (!header) return;
    const top = `${Math.round(header.getBoundingClientRect().bottom)}px`;
    bindings.forEach(({ panel }) => panel.style.setProperty('--asap-main-mega-top', top));
  }

  function cancelClose() { clearTimeout(closeTimer); }
  function closeAll(returnFocus) {
    cancelClose();
    bindings.forEach(({ trigger, panel }) => {
      panel.hidden = true;
      panel.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
    });
    if (returnFocus) returnFocus.focus();
  }
  function open(binding) {
    cancelClose();
    updateTop();
    bindings.forEach(({ trigger, panel }) => {
      const active = panel === binding.panel;
      panel.hidden = !active;
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
    });
  }
  function scheduleClose() {
    cancelClose();
    closeTimer = setTimeout(() => closeAll(), 140);
  }

  bindings.forEach((binding) => {
    const { trigger, panel, item } = binding;
    trigger.addEventListener('pointerenter', () => open(binding));
    trigger.addEventListener('focus', () => open(binding));
    item.addEventListener('pointerenter', cancelClose);
    item.addEventListener('pointerleave', scheduleClose);
    panel.addEventListener('pointerenter', cancelClose);
    panel.addEventListener('pointerleave', scheduleClose);
    item.addEventListener('focusout', (event) => {
      if (!event.relatedTarget || (!item.contains(event.relatedTarget) && !panel.contains(event.relatedTarget))) scheduleClose();
    });
    panel.addEventListener('focusout', (event) => {
      if (!event.relatedTarget || (!item.contains(event.relatedTarget) && !panel.contains(event.relatedTarget))) scheduleClose();
    });
    const escape = (event) => {
      if (event.key === 'Escape' && !panel.hidden) closeAll(trigger);
    };
    item.addEventListener('keydown', escape);
    panel.addEventListener('keydown', escape);
  });

  document.addEventListener('pointerdown', (event) => {
    const inside = bindings.some(({ item, panel }) => item.contains(event.target) || panel.contains(event.target));
    if (!inside) closeAll();
  });
  window.addEventListener('resize', updateTop, { passive: true });
  window.addEventListener('scroll', updateTop, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
